export default __webpack_public_path__ + "static/cursor-13b67f768a2cdb93ee50dd9cb1db5d91.png";